<template>
  <div
    v-if="energyLabel"
    class="energy-label-container"
  >
    <EnergyLabel
      :energy-class="energyLabel.class"
      class="energy-label-container"
      :products="energyLabel.products"
      :alignment="datasheetAlignment"
      @click="openEnergyModal"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent, type PropType } from 'vue';
import { EnergyLabel } from '@i22/td-longtail-vue-components';
import { getEnergyEfficiencyProduct, type EnergyEfficiencyCollection } from '@i22/rocket';
import type { BundleProduct, StandardProduct } from '~/lib/goliath/goliath.types';
import { openModal } from '~/composables/modal';

const props = defineProps({
  product: {
    type: Object as PropType<StandardProduct | BundleProduct>,
    required: true,
  },
  datasheetAlignment: {
    type: String,
    default: 'default',
    validator(value: string) {
      return ['default', 'bottom', 'justify', 'left'].includes(value);
    },
  },
});

const energyLabel = computed<EnergyEfficiencyCollection | undefined>(() =>
  getEnergyEfficiencyProduct(props.product)
);

const openEnergyModal = () => {
  openModal({
    component: {
      is: defineAsyncComponent(() => import('~/components/energy-label-modal.vue')),
      props: {
        energyLabel: energyLabel.value,
      },
    },
  });
};

defineExpose({ energyLabel });
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
.energy-label-slide {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__head {
    display: flex;
    align-items: center;
    margin-bottom: 6px;

    &-label {
      line-height: 0.9;
      margin-right: 0.75rem;
      margin-top: -2px;
      @include font-size(24px, 30px);
    }
  }
}
</style>
